
$(document).ready(function () {



  
$('aside.trans_filter_aside').css('display','none')  
  if ($(window).width() < 992) {  
        $('.not_transparent aside').css('display','none');
     $('.filter_trans_header #shopify-section-header sticky-header').css("top","0"); 
    }
   
var $element = $('aside.trans_filter_aside'); 
  var specialOccasionValue;
    $(window).on('scroll', function() {
          var specialOcassioncollection =$("#collectionName");
          if (specialOcassioncollection !== "" && specialOcassioncollection.length >0) {
          specialOcassioncollection = $(specialOcassioncollection).attr('value');
          } else{
          specialOcassioncollection = "search"; 
          }
      
    if ($(window).scrollTop() > 0) {
      
       $('aside').css('display','block');
       $element.removeClass('new-filter-header');
   
    } else if($(window).scrollTop() == 0) {
     $('.index_page.page-t3-gemstone:not(.filter_trans_header) aside').css('display','none')
    if ($(window).width() < 992) {  
        setTimeout(function(){ $('aside.trans_filter_aside').css('display','none'); },10);
     }  
      
          if(specialOccasionValue){
  
            if(specialOccasionValue == 'yes'){
          } else{
              $element.addClass('new-filter-header');
          }
          }   
        } else{
           if ($(window).width() < 992) {  
              setTimeout(function(){ $('aside.trans_filter_aside').css('display','none'); },10);
           }  
          if(specialOccasionValue){
             if(specialOccasionValue == 'yes'){
          } else{
              $element.addClass('new-filter-header');
          }
          }  
        }
    });

  
    var $element2 = $('.collection aside.trans_header_filter'); 
    $(window).on('scroll', function() { 

        if ($(window).scrollTop() > 40) {
           $element2.removeClass('new-filter-header-cstm');
        } else if($(window).scrollTop() < 40 ){
          console.log(0000)
          $element2.addClass('new-filter-header-cstm');
        }else {
        //   $element2.addClass('new-filter-header-cstm');
        }
    });
  });
  

$(document).ready(function () {
  function setCookie(cname, cvalue, exdays,path) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + `;path=${path}`;
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
$('.filter_count_non_zero').show();
if($(".facets__wrapper .newProductCount-top").length > 0){
$(".facets__wrapper .newProductCount-top").before("<div class='contentPrice'><input type='checkbox' id='seeprice'/> Show Price</div>");
}else{
  $(".facets__wrapper ").append("<div class='contentPrice'><input type='checkbox'  id='seeprice'/> Show Price</div>");
}
    $(document).on('change',"#seeprice",function () {
        if ($(this).is(":checked")) {
            var show_price = getCookie("show_price");
            if(show_price != 'true'){
             setCookie("show_price", 'true', 1,window.location.pathname);
            }
            sessionStorage.setItem("seeprice", true);
            $(".price").addClass("not_hidden");
            $(".card_special").css('opacity','1');
         } else {
            var show_price = getCookie("show_price");
            if(show_price != 'false'){
            setCookie("show_price", 'false', 1,window.location.pathname);
            }
            sessionStorage.setItem("seeprice", false);
            $(".price").removeClass("not_hidden");
            $(".card_special").css('opacity','0');
        }
    });
    var see__price = $('.see_price').text();
    var show_price = getCookie("show_price");

  
    if(see__price == 'true'  && show_price != 'true' && show_price != 'false' ){
    sessionStorage.setItem("seeprice", true);
    $(".price").addClass("not_hidden");
    $(".card_special").css('opacity','1');
    $('#seeprice').attr('checked', 'checked'); 
    }
    else if(show_price == 'true'){
      sessionStorage.setItem("seeprice", true);
    $(".price").addClass("not_hidden");
    $(".card_special").css('opacity','1');
    $('#seeprice').attr('checked', 'checked'); 
    }
    else{
    sessionStorage.setItem("seeprice", false);
    $(".price").removeClass("not_hidden");
    $(".card_special").css('opacity','0');
    $('#seeprice').removeAttr('checked');  
    } 
      if(see__price == 'false'){
     $(".contentPrice").css('opacity','0');
     $('#seeprice').removeAttr('checked');
     $(".price").removeClass("not_hidden");
     sessionStorage.setItem("seeprice", false);
  } else{
     $(".contentPrice").css('opacity','1');
      if(show_price == 'true'){
         $('#seeprice').attr('checked', 'checked'); 
         $(".price").addClass("not_hidden");
         sessionStorage.setItem("seeprice", true);
      } else{
          $('#seeprice').removeAttr('checked');
         $(".price").removeClass("not_hidden");
         sessionStorage.setItem("seeprice", false); 
      } 
     

        
  }
});



  

$(document).ready(function() {

    var contenCuadros = document.getElementsByClassName('contenCuadro');

    for (let i = 0; i < contenCuadros.length; i++) {
        var contenCuadro = contenCuadros[i];
        var lis = contenCuadro.getElementsByTagName('li');

        for (let j = 0; j < lis.length; j++) {
            var li = lis[j];
            li.classList.add('cuadro');
        }
    }

    var startDate = document.getElementById('startDate').value;
    var endDate = document.getElementById('endDate').value;
    var specialOccasionStartDate = new Date(startDate);
    var specialOccasionEndDate = new Date(endDate);
    var today = new Date();
    var countbannerload = 0;
    //var specialOcassioncollection = document.getElementById('collectionName').value;
       var specialOcassioncollection =$("#collectionName");
          if (specialOcassioncollection !== "" && specialOcassioncollection.length >0) {
          specialOcassioncollection = $(specialOcassioncollection).attr('value');
          } else{
          specialOcassioncollection = "search"; 
          }
  

     let totalCountco = 0;
  
sp_filter();


function sp_filter_quick_view(){
$(".cstm-hide-select option").each(function(index) {
var qntyship = $(this).data('qntylessship');
var price = $(this).data('pricee');
var qnty = $(this).data('qnty');
var attrpid = $(this).data('attrpid');  
var skipDates = $('.skipDatesMeta').text();
var qnty_less_data_meta = $('.qnty_less_data_meta').text();
let qnty_less_data;
    
if(qntyship == null){
   qnty_less_data = qnty_less_data_meta;
  } else{
  qnty_less_data = qntyship;       
 } 


if(window.location.href.indexOf('engagement-ring-settings-with-gemstone')>-1){
let wizardInfo_gemstone = localStorage.getItem('wizardInfo_gemstone');   
if(wizardInfo_gemstone){
let vendorName = JSON.parse(wizardInfo_gemstone);
    if(vendorName.gemstone_deliver_date != undefined || vendorName.gemstone_deliver_date != null ){
    var vendor_Shipping_date = vendorName.gemstone_deliver_date;
    }
}
} 
else{
let wizardInfo = localStorage.getItem('wizardInfo');  
if(wizardInfo){
let vendorName = JSON.parse(wizardInfo);
    if(vendorName.stone_vendor_name != undefined || vendorName.stone_vendor_name != null ){
    var vendor_Shipping_date = vendorName.stone_delivery;
    }
}
  
} 




 if(vendor_Shipping_date == null){
   qnty_less_data = qnty_less_data;
  } else{
  qnty_less_data = parseInt(qnty_less_data) + parseInt(vendor_Shipping_date);  

 }     

if(qnty_less_data < 10){

console.log(qnty_less_data);
  
 $('.Ocassion_notdata .grid_quick_'+attrpid).addClass('lessqnty');
   if(qnty_less_data == 0){
           qnty_less_data_updated = parseInt(qnty_less_data) + 1;
         } else{
           qnty_less_data_updated = qnty_less_data;
         }
  
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
            
            let today = new Date();
            var pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
           
             
             if(hh > 15){
               if(qnty_less_data == 0){
              var dd = today.getDate() + 1 ; 
               } else{
               var dd = today.getDate() + 2 ;  
               }
               
             }  else{
               if(qnty_less_data == 0){
              var dd = today.getDate(); 
               } else{
               var dd = today.getDate() + 1 ;  
               }
             }
             
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
            
            var startDateRange = yyyy + '/' + mm + '/' + dd;
            startDateRange = new Date(startDateRange);

            var startDateOUtUs = yyyy + '/' + mm + '/' + dd;
            startDateOUtUs = new Date(startDateOUtUs); 
            var endDate = "";
            var endDateoutus = "";
            var endDateRange = "";

            var country_loc = localStorage.getItem("countryus");
        
              if(country_loc == 'yes'){
                if(price < 251 ){
                    if(qnty_less_data == 0){
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   } else{
                       var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                    
                } else{
                  if(qnty_less_data == 0){
                     var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 1 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 4 ; 
                   } else{
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                }  
            } else{
             
             if(qnty_less_data == 0){
                      var noOfDaysToAddoutusa = parseInt(qnty_less_data_updated) + 1;  
                   } else{
                      var noOfDaysToAddoutusa = qnty_less_data_updated; 
                   }   
              }
               
          
            var countoutus = 0;
            while(countoutus < noOfDaysToAddoutusa ){
                endDateoutus = new Date(startDateOUtUs.setDate(startDateOUtUs.getDate() + 1)); 
           
               if (skipDates.includes(endDateoutus.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateoutus.getDay() != 0 && endDateoutus.getDay() != 6 &&  !skipDates.includes(startDateOUtUs.toISOString().substring(0, 10))) {

                  countoutus++;
                }
             }
        
            var count = 0;
            while(count < noOfDaysToAdd ){
                endDate = new Date(startDate.setDate(startDate.getDate() + 1));
            
              //  if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
              //     continue;
              // }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
                        
                  count++;
                }
             }
              
              var count1 = 0;
              while(count1 < noOfDaysToAddrange ){
                endDateRange = new Date(startDateRange.setDate(startDateRange.getDate() + 1)); 
               if (skipDates.includes(endDateRange.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateRange.getDay() != 0 && endDateRange.getDay() != 6 &&  !skipDates.includes(startDateRange.toISOString().substring(0, 10))) {
                  
                  count1++;
                }
             }
       
            var weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
           
            
              
               var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                 
                    var newDateRange =  new Date(endDateRange.getTime());

                    var newDaten =  new Date(endDateRange.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDateRange =  new Date(endDateRange.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateRange.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDateRange =  new Date(endDateRange.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateRange.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDateRange =  new Date(endDateRange.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateRange.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDateRange =  new Date(endDateRange.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                 
                   var newDate =  new Date(endDate.getTime());
            
                    var newDaten =  new Date(endDate.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                         
                      
                          var newDate =  new Date(endDate.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDate.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDate.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDate.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDate.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                          
            
                              var newddRange = newDateRange.getDate();
                              var newmmRange = newDateRange.getMonth() + 1;
                              let dayRange = weekday[newDateRange.getDay()];
                             
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                            if(newddRange == "1" || newddRange == "21" || newddRange == "31"){
                                var daytrange = newddRange+'st';
                              } else if(newddRange == "2" || newddRange == "22"){
                                 var daytrange = newddRange+'nd';
                              } else if(newddRange == "3" || newddRange == "33"){
                                var daytrange = newddRange+'rd';
                              } else{
                                var daytrange = newddRange+'th';
                              }

                            if(price < 251 ){
                               var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayRange+', '+monthNames[newDateRange.getMonth()] + ' ' +daytrange;
                            } else{
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +dayt ;
                            }  
                 
                            var text = document.createTextNode(finalDate);
                                  
                  
                } else{
            
             
                   var newDate =  new Date(endDateoutus.getTime());
           
                    var newDaten =  new Date(endDateoutus.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDate =  new Date(endDateoutus.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateoutus.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDateoutus.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateoutus.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDateoutus.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
      
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                           
                            
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd ;
                            
                 
                           
                  
                 }

                   var date3 = new Date(newDate);
                   var date4 = new Date(newDateRange);
                   var currentDate = new Date();
        
                 console.log(date3);
                   if(price < 251 ){ 

                    
                   var differenceInMillis = date4 - currentDate;
                   
                   } else{
                   
                  var differenceInMillis = date3 - currentDate; 
                   } 
              
                   var differenceInDays = Math.floor(differenceInMillis / (1000 * 60 * 60 * 24));
                 $(this).addClass(differenceInDays);
              setTimeout(function(){ 
                  if (differenceInDays <= 10 ) {
                  console.log(date3+'-'+differenceInDays);
                    $('.Ocassion_quick_data').addClass('grid_quick_ul');
                    $('.Ocassion_quick_data .grid_quick_'+attrpid).addClass('showData');
                 
                  }  
              },2000);

                
} 
});

}  




  
function sp_filter(){
//$('.custom_product_collection_title_wrapper').addClass('hasocassion'); 
$('aside').addClass('spocassion');     
$(".cstm-hide-select option").each(function() {
var qntyship = $(this).data('qntylessship');
var price = $(this).data('pricee');
var qnty = $(this).data('qnty');
var attrpid = $(this).data('attrpid');  
var skipDates = $('.skipDatesMeta').text();
var qnty_less_data_meta = $('.qnty_less_data_meta').text();
    
if(qntyship == null){
   var qnty_less_data = qnty_less_data_meta;
  } else{
  var qnty_less_data = qntyship;       
 } 

        if(qnty_less_data == 0){
           qnty_less_data_updated = parseInt(qnty_less_data) + 1;
         } else{
           qnty_less_data_updated = qnty_less_data;
         }
              var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
            
            let today = new Date();
            var pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
           
             
             if(hh > 15){
               if(qnty_less_data == 0){
              var dd = today.getDate() + 1 ; 
               } else{
               var dd = today.getDate() + 2 ;  
               }
               
             }  else{
               if(qnty_less_data == 0){
              var dd = today.getDate(); 
               } else{
               var dd = today.getDate() + 1 ;  
               }
             }
             
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
            
            var startDateRange = yyyy + '/' + mm + '/' + dd;
            startDateRange = new Date(startDateRange);

            var startDateOUtUs = yyyy + '/' + mm + '/' + dd;
            startDateOUtUs = new Date(startDateOUtUs); 
            var endDate = "";
            var endDateoutus = "";
            var endDateRange = "";

            var country_loc = localStorage.getItem("countryus");
        
              if(country_loc == 'yes'){
                if(price < 251 ){
                    if(qnty_less_data == 0){
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   } else{
                       var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                    
                } else{
                  if(qnty_less_data == 0){
                     var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 1 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 4 ; 
                   } else{
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                }  
            } else{
             
             if(qnty_less_data == 0){
                      var noOfDaysToAddoutusa = parseInt(qnty_less_data_updated) + 1;  
                   } else{
                      var noOfDaysToAddoutusa = qnty_less_data_updated; 
                   }   
              }
               
          
            var countoutus = 0;
            while(countoutus < noOfDaysToAddoutusa ){
                endDateoutus = new Date(startDateOUtUs.setDate(startDateOUtUs.getDate() + 1)); 
           
               if (skipDates.includes(endDateoutus.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateoutus.getDay() != 0 && endDateoutus.getDay() != 6 &&  !skipDates.includes(startDateOUtUs.toISOString().substring(0, 10))) {

                  countoutus++;
                }
             }
        
            var count = 0;
            while(count < noOfDaysToAdd ){
                endDate = new Date(startDate.setDate(startDate.getDate() + 1));
            
              //  if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
              //     continue;
              // }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
                        
                  count++;
                }
             }
              
              var count1 = 0;
              while(count1 < noOfDaysToAddrange ){
                endDateRange = new Date(startDateRange.setDate(startDateRange.getDate() + 1)); 
               if (skipDates.includes(endDateRange.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateRange.getDay() != 0 && endDateRange.getDay() != 6 &&  !skipDates.includes(startDateRange.toISOString().substring(0, 10))) {
                  
                  count1++;
                }
             }
       
            var weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
           
            
              
               var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                 
                    var newDateRange =  new Date(endDateRange.getTime());

                    var newDaten =  new Date(endDateRange.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDateRange =  new Date(endDateRange.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateRange.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDateRange =  new Date(endDateRange.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateRange.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDateRange =  new Date(endDateRange.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateRange.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDateRange =  new Date(endDateRange.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                 
                   var newDate =  new Date(endDate.getTime());
            
                    var newDaten =  new Date(endDate.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                         
                      
                          var newDate =  new Date(endDate.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDate.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDate.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDate.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDate.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                          
            
                              var newddRange = newDateRange.getDate();
                              var newmmRange = newDateRange.getMonth() + 1;
                              let dayRange = weekday[newDateRange.getDay()];
                             
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                            if(newddRange == "1" || newddRange == "21" || newddRange == "31"){
                                var daytrange = newddRange+'st';
                              } else if(newddRange == "2" || newddRange == "22"){
                                 var daytrange = newddRange+'nd';
                              } else if(newddRange == "3" || newddRange == "33"){
                                var daytrange = newddRange+'rd';
                              } else{
                                var daytrange = newddRange+'th';
                              }

                            if(price < 251 ){
                               var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayRange+', '+monthNames[newDateRange.getMonth()] + ' ' +daytrange;
                            } else{
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +dayt ;
                            }  
                 
                            var text = document.createTextNode(finalDate);
                                  
                  
                } else{
            
             
                   var newDate =  new Date(endDateoutus.getTime());
           
                    var newDaten =  new Date(endDateoutus.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDate =  new Date(endDateoutus.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateoutus.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDateoutus.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateoutus.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDateoutus.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
      
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                           
                            
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd ;
                            
                 
                           
                  
                 }

                   var endDateSpecial = $('.end_date_sp').text();
                   var startDateSpecial = $('.start_date_sp').text();
                   var date2 = new Date(endDateSpecial);
                   var date1 = new Date(startDateSpecial);
                   var date3 = new Date(newDate);
                   var date4 = new Date(newDateRange);
              
                if(country_loc == "yes") {  
                if(price < 251 ){
              
                  if (date4 > date1 && date4 <= date2) {
                  
                  document.getElementById('special_ocassion_collection').style.display = 'flex'; 
                   $('.custom_product_collection_title_wrapper').removeClass('hasocassion'); 
                   $('aside').removeClass('spocassion');   
                   // $('.custom_product_collection_title_wrapper').addClass('hasocassion'); 
                   $('.tagnewspecial_'+attrpid).css('display', 'flex');
                  // $('.Ocassion_data .grid_special_'+attrpid).css('display','flex');
                 // $('.Ocassion_data .grid_special_'+attrpid).addClass('showData');
                      
                       $('#quick_view_collection').css('display','none');
                    
                   
                    $(this).addClass(date4+' '+date1+' '+date2);
                  } else{
                     
                  
                 
                  }
                  
                } else{
                if (date3 > date1 && date3 < date2) {
               
                document.getElementById('special_ocassion_collection').style.display = 'flex'; 
                   $('.custom_product_collection_title_wrapper').removeClass('hasocassion'); 
                   $('aside').removeClass('spocassion');   
                //$('.custom_product_collection_title_wrapper').addClass('hasocassion'); 
                  $('.tagnewspecial_'+attrpid).css('display', 'flex');
                //  $('.Ocassion_data .grid_special_'+attrpid).css('display','flex');
                 // $('.Ocassion_data .grid_special_'+attrpid).addClass('showData');
                 
                        $('#quick_view_collection').css('display', 'none');
                  

                   $(this).addClass(date3+' '+date1+' '+date2);
                  } else{

                  }
                 
                }  
                  
                }

                 var counting = $('.grid__item.showData').length;
                  if(counting == 0){
                  //  localStorage.removeItem('specialOccasionValue' + specialOcassioncollection);
                  }
                 $('.filter_count_zeroo').text(`${counting}  Result(s)`);
                  var text = document.createTextNode(finalDate).textContent;
          
                //document.getElementById('est_delivery_date').innerHTML = text;
                //document.getElementById('delivery_date').value = text;  
                 $(this).addClass(text);  
  
})

} 


    var counta = 0;
    $(".inventory_detail").each(function() {
        var variant_qnty = $(this).attr("data-attr");
        if (variant_qnty > 0) {
            counta++;
        }

    })

if (counta == "0") {
        $(".inventory_detail").each(function() {
            var variantLessArray = $(this).attr('data-less').slice(0, -1);
            var variantLessValues = variantLessArray.split(',');
            var skipDates = $('.skipDatesMeta').text();

            if (variantLessValues.length > 0 && variantLessArray != "") {

               let todayco = new Date();
                var pstDate = todayco.toLocaleString("en-US", { timeZone: "America/New_York" });
                let hhco = new Date(pstDate).getHours();
           
               

                if (hhco > 15) {
                 
                     var ddco = todayco.getDate() + 5; 
                  
                } else{
                
                  
                     var ddco = todayco.getDate() + 4;
                 
                }                    
               

                let mmco = todayco.getMonth() + 1;
                let yyyyco = todayco.getFullYear();

                var startDateco = yyyyco + '/' + mmco + '/' + ddco;
                startDateco = new Date(startDateco);

                var endDateco = '';
                var noOfDaysToAddco;
                var countco = 0;
                var counttimes = 0;

                for (let i = 0; i < variantLessValues.length; i++) {
                    noOfDaysToAddco = variantLessValues[i];

                    while (countco < noOfDaysToAddco) {
                        endDateco = new Date(startDateco.setDate(startDateco.getDate() + 1));
                    // if (skipDates.includes(endDateco.toISOString().substring(0, 10))) {
                    //      continue;
                    //     }
                     // if (endDateco.getDay() != 0 && endDateco.getDay() != 6 && !skipDates.includes(startDateco.toISOString().substring(0, 10))) {
                        
                        if (endDateco.getDay() != 0 && endDateco.getDay() != 6 ) {
                            countco++;
                          totalCountco++;
                        }
                    }

                    if (endDateco >= specialOccasionStartDate && endDateco <= specialOccasionEndDate) {

                       // document.getElementById('special_ocassion_collection').style.display = 'flex';

                        break;
                    } else {
                        continue;

                    }
                }


            } else {

              //  document.getElementById('special_ocassion_collection').style.display = 'flex';
            }
        });
    } else {
      //  document.getElementById('special_ocassion_collection').style.display = 'flex';
    }
   
var current_url = window.location.href;
var url_part2 =  current_url.split('filter.p.m')[1];



  
$(".second-input.custom-radio-buttons input").change(function() {
    window.scrollTo(0, 0);
  
    var first_input_data1 = $(".second-input.custom-radio-buttons input:checked").val();
       
         if (first_input_data1 == 'yes') {
            $('.ocassion_loader').css('display','flex');
             $('.toggle-outside').addClass("toggel-active");
           
      
           

        
 
          var url = "?view=quick_ship_dyor";
      
          $.ajax({
              url: url,
              type: 'GET',
      
              success: function(res) {
                 $('.Ocassion_notdata').hide();
                 $('.quick_data_div').html(res);
                
                   sp_filter_quick_view() 
                  $('.ocassion_loader').css('display','none');
                  setTimeout(function() {
                    
                      $('.slider.slider-products:not(.slick-initialized)').slick({
                             dots: true,
                             infinite: true,
                             responsive: [{
                                 breakpoint: 1024,
                                 settings: {
                                     infinite: true,
                                     dotsClass: 'custom_paging'
                                 }
                             }]
                         });
                     }, 2000);
                 metal_hide();
                 
              }
           
     
          });


  
       
        
     
    
      
    
          
     } else {
        $('.Ocassion_notdata').show();
        $('.Ocassion_notdata').removeClass('grid_quick_ul');
        $('.jtpl_collection_prd_pop_up').css('display','flex');
        $('.prod.contenCuadro').css('display','flex');
        $('.grid__item').removeClass('showData');

         $('.toggle-outside').removeClass("toggel-active");
     }

 });


  
$(".third-input.custom-radio-buttons input").change(function() {
    window.scrollTo(0, 0);
     
    setTimeout(function() {
         $('.slider.slider-products').slick("unslick");
     }, 100);

     setTimeout(function() {
      $('.slider.slider-products:not(.slick-initialized)').slick({
             dots: true,
             infinite: true,
             responsive: [{
                 breakpoint: 1024,
                 settings: {
                     infinite: true,
                     dotsClass: 'custom_paging'
                 }
             }]
         });
     }, 2000);

     var first_input_data1 = $(".third-input.custom-radio-buttons input:checked").val();
    
      if (first_input_data1 == 'yes') {
       // $('.Ocassion_notdata').addClass('loaderOp');
        $('.ocassion_loader').css('display','flex');
         $('.quick_data_div').show();
        var current_url = window.location.href;
        
          var url = `${current_url}?filter.p.tag=inventory-greater-1`;
            
          $.ajax({
              url: url,
              type: 'GET',
      
              success: function(res) {
                 $('.Ocassion_notdata').hide();
                var hura_tip = $(res).find('#Huratips-Loop').prop('outerHTML');
                
                 $('.quick_data_div').html(hura_tip);
                //  $('.Ocassion_notdata').removeClass('loaderOp');
                  $('.ocassion_loader').css('display','none');
                    setTimeout(function() {
                       $('.quick_data_div #Huratips-Loop').css('margin-top','80px'); 
                    $('.slider.slider-products:not(.slick-initialized)').slick({
                             dots: true,
                             infinite: true,
                             responsive: [{
                                 breakpoint: 1024,
                                 settings: {
                                     infinite: true,
                                     dotsClass: 'custom_paging'
                                 }
                             }]
                         });
                     }, 100);
                
                 
              }
           
     
          });

         $('body').addClass("filter_trans_header");
         $('.Ocassion_data_quick').show();
         $('.Ocassion_notdata').hide();
         $('#Huratips-Loop1').hide();
         
         $('.Ocassion_data_quick').addClass("quickViewenabled");
         $('.toggle-outside-quick').addClass("toggel-active-quick");
         $('.jtpl_collection_prd_pop_up').css('display','none');
        $('.prod.contenCuadro').css('display','none');
        $('.quickViewenabled li.showQuick').css('display','flex');
        $('.Ocassion_data').hide();
        $('#Huratips-Pagination').hide(); 
        $('.toggle-outside-sp').removeClass("toggel-active");
    } else {
         $('.quick_data_div #Huratips-Loop').remove(); 
        $('body').removeClass("filter_trans_header");
         $('.Ocassion_data_quick').hide();
         $('.Ocassion_notdata').show();
         $('#Huratips-Loop').show();
         $('#Huratips-Loop1').show();
          $('#Huratips-Pagination').show(); 
         $('.Ocassion_data_quick').removeClass("quickViewenabled");
         $('.toggle-outside-quick').removeClass("toggel-active-quick");
         $('.jtpl_collection_prd_pop_up').css('display','flex');
        $('.prod.contenCuadro').css('display','flex');
     }

 });








    var countbannerchange = 0;
 $(".first-input.custom-radio-buttons input").change(function() {
  console.log(`<<<<<<<<<<<<<<<<<<<<<<<cstm test ajax run?????????>>>>>>>>>>>>>>>>>>>>>>>>>>>>`);
    window.scrollTo(0, 0);
     // setTimeout(function() {
     //     $('.slider.slider-products').slick("unslick");
     // }, 100);

     // setTimeout(function() {
     //  $('.slider.slider-products:not(.slick-initialized)').slick({
     //         dots: true,
     //         infinite: true,
     //         responsive: [{
     //             breakpoint: 1024,
     //             settings: {
     //                 infinite: true,
     //                 dotsClass: 'custom_paging'
     //             }
     //         }]
     //     });
     // }, 2000);
    var first_input_data1 = $(".first-input.custom-radio-buttons input:checked").val();
       
      if (first_input_data1 == 'yes') {
        $('.ocassion_loader').css('display','flex');
        var current_url = window.location.href;
        var url = `${current_url}?filter.p.tag=sp`;
       // var url = "?view=special_ocassion";
            
          $.ajax({
              url: url,
              type: 'GET',
      
              success: function(res) {
                $('.quick_data_div').hide();
                 $('.Ocassion_notdata').hide();
                
                  var hura_tip1 = $(res).find('.huratip-pagination-outer').prop('outerHTML');
                console.log(hura_tip1);
                 $('.sp_data_div').html(hura_tip1);
    
                $('.ocassion_loader').css('display','none');
                    setTimeout(function() {
                        $('.sp_data_div #Huratips-Loop').css('margin-top','80px'); 
                      $('.col_card_gift_svg').css('display','block');
                    $('.slider.slider-products:not(.slick-initialized)').slick({
                             dots: true,
                             infinite: true,
                             responsive: [{
                                 breakpoint: 1024,
                                 settings: {
                                     infinite: true,
                                     dotsClass: 'custom_paging'
                                 }
                             }]
                         });
                     }, 100);
                var dynamicScript = document.createElement('script');
                dynamicScript.type = 'text/javascript';
                dynamicScript.text = `
                  var endlessScroll = new Ajaxinate({
                    container: '#Huratips-Loop',
                    pagination: '#Huratips-Pagination',
                    loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
                    callback: myfunction
                  });
                    
                    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));   

                `;
                document.body.appendChild(dynamicScript);
       
                 
              }
           
     
          });


        
        setTimeout(function() {
             $('.Ocassion_data').show();
             $('.Ocassion_notdata').hide();
             $('#Huratips-Loop').hide();
             $('#Huratips-Loop1').hide();
             var counting2 = $('.grid__item.showData').length;
             $('.filter_count_zeroo').text(`${counting2}  Result(s)`);
         }, 100);
         $('.toggle-outside-sp').addClass("toggel-active");
         $('.Ocassion_data_quick').hide();
          $('.Ocassion_data_quick').removeClass("quickViewenabled");
          $('.toggle-outside-quick').removeClass("toggel-active-quick");
          $('body').addClass("filter_trans_header");
       
         $(".inventory_detail").each(function() {
             var variant_qnty = $(this).attr("data-attr");
             var variantLessValues = $(this).attr('data-less').split(',');

             if (variant_qnty > 0) {
                 countbannerchange++;
                 // $('.jtpl_sp').hide();
                 $('.jtpl_sp_anchor').show();
                 $('.jtpl_filter_count').hide();
                 $('.jtpl_special_count').show();

             } else {
                 if (variantLessValues.length > 0) {
                     let todayco = new Date();
                     let hhco = todayco.getHours();

                     if (todayco.getHours() > 23) {
                         var ddco = todayco.getDate() + 1;
                     } else {
                         var ddco = todayco.getDate();
                     }

                     let mmco = todayco.getMonth() + 1;
                     let yyyyco = todayco.getFullYear();

                     var startDateco = yyyyco + '/' + mmco + '/' + ddco;
                     startDateco = new Date(startDateco);

                     var endDateco = '';
                     var noOfDaysToAddco;
                     var countco = 0;
                     var counttimes = 0;

                     for (let i = 0; i < variantLessValues.length; i++) {
                         noOfDaysToAddco = variantLessValues[i];

                         while (countco < noOfDaysToAddco) {
                             endDateco = new Date(startDateco.setDate(startDateco.getDate() + 1));

                             if (endDateco.getDay() != 0 && endDateco.getDay() != 6) {
                                 countco++;
                             }
                         }

                         if (endDateco >= specialOccasionStartDate && endDateco <= specialOccasionEndDate) {
                             countbannerchange++;
                             // $(this).closest('.grid__item').show();

                             // $('.jtpl_sp').hide();
                             $('.jtpl_sp_anchor').show();
                             $('.jtpl_filter_count').hide();
                             $('.jtpl_special_count').show();
                             $('.toggle-outside-sp').addClass("toggel-active");
                           $('.Ocassion_data_quick').hide();
                            $('.Ocassion_data_quick').removeClass("quickViewenabled");
                            $('.toggle-outside-quick').removeClass("toggel-active-quick");
                           $('body').addClass("filter_trans_header");
                             break; // Stop iterating if a match is found
                         } else {
                             continue;
                         }
                     }

                     if (!endDateco || endDateco < specialOccasionStartDate || endDateco > specialOccasionEndDate) {
                         //  $(this).closest('.grid__item').hide();
                     }
                 } else {
                     //  $(this).closest('.grid__item').hide();
                 }
             }
         });
         countbannerchange = 0;
     } else {
         $('.sp_data_div .huratip-pagination-outer').remove(); 
         $('.Ocassion_data').hide();
         $('.Ocassion_notdata').show();
         $('#Huratips-Loop').show();
         $('#Huratips-Loop1').show();
          $('#Huratips-Pagination').show(); 
         $(".inventory_detail").each(function() {
             var variant_qnty = $(this).attr("data-attr");

             if (variant_qnty == 0) {
                 $('.jtpl_sp').show();
                 $('.jtpl_sp_anchor').hide();
                 $('.jtpl_filter_count').show();
                 $('.jtpl_special_count').hide();
                 $('.toggle-outside-sp').removeClass("toggel-active");
               $('body').removeClass("filter_trans_header");
                 // $(this).closest('.grid__item').show();

             }
         });
     }

 });



});
  
class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = (event) => {
            if (event.target.id == "seeprice" || event.target.id == "Filter-Price-GTE" || event.target.id == "Filter-Price-LTE") {
                return;
            }


            return this.onSubmitHandler(event);
        };

        const facetForm = this.querySelector("form");
      // facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
     if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll(".js-facet-remove").forEach((element) => {
            element.classList.toggle("disabled", disable);
        });
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        let actualParams = new URLSearchParams(window.location.search);
        let params = new URLSearchParams(formData);
        let keysForDel = [];
        params.forEach((value, key) => {
            if (value == "" && key.indexOf("dyo_carat_") == -1 && key.indexOf("dyo_shape_") == -1 && key.indexOf("sw") == -1) {
                keysForDel.push(key);
            }
        });
      console.log(keysForDel);

        // now let's keep the params dyo_carat_ and dyo_shape and sw if present in actualParams
        actualParams.forEach((value, key) => {
            if (key.indexOf("dyo_carat_") != -1 || key.indexOf("dyo_shape_") != -1 || key.indexOf("sw") != -1) {
                params.append(key, value);
            }
        });

        keysForDel.forEach((key) => {
            params.delete(key);
        });

        return params.toString();
    }

    onSubmitForm(searchParams, event) {
        window.location.assign(`${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll("facet-filters-form form");
        if (event.srcElement.className == "mobile-facets__checkbox") {
            const searchParams = this.createSearchParams(event.target.closest("form"));
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (
                        form.id === "FacetSortForm" ||
                        form.id === "FacetFiltersForm" ||
                        form.id === "FacetSortDrawerForm"
                    ) {
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === "FacetFiltersFormMobile") {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join("&"), event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf("?") == -1
                ? ""
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
        window.location.assign(`${window.location.pathname}?${url}`);
    }
}

customElements.define("facet-filters-form", FacetFiltersForm);

class PriceRange extends HTMLElement {
    constructor() {
        super();
         this.querySelectorAll("input").forEach((element) =>
             element.addEventListener("change", this.onRangeChange.bind(this))
        );
       // this.setMinAndMaxValues();
    }

    onRangeChange(event) {
       // this.adjustToValidValues(event.currentTarget);
       // this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll("input");
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute("max", maxInput.value);
        if (minInput.value) maxInput.setAttribute("min", minInput.value);
        if (minInput.value === "") maxInput.setAttribute("min", 0);
        if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute("min"));
        const max = Number(input.getAttribute("max"));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector("a");
      if (facetLink) {
        facetLink.setAttribute("role", "button");
        facetLink.addEventListener("click", this.closeFilter.bind(this));
        facetLink.addEventListener("keyup", (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
        });
      }
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
    }
}

customElements.define("facet-remove", FacetRemove);
